import React from 'react';
import { classNames } from '../atoms';

type GridAlign = 'start' | 'end' | 'center' | 'baseline' | 'stretch';
type GridGap = 0 | 1 | 2 | 3 | 4 | 5;
type GridJustify = 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly';

export interface GridRowProps extends React.HTMLAttributes<HTMLDivElement> {
  align?: GridAlign;
  gap?: GridGap;
  justify?: GridJustify;
}

const GridRow = React.forwardRef<HTMLDivElement, GridRowProps>(({
  align,
  className,
  children,
  gap,
  justify,
  ...props
}, ref) => (
  <div
    ref={ref}
    className={classNames(
      'row',
      gap !== undefined ? `g-${gap}` : undefined,
      align ? `align-items-${align}` : undefined,
      justify ? `justify-content-${justify}` : undefined,
      className,
    )}
    {...props}
  >
    {children}
  </div>
));

GridRow.displayName = 'GridRow';

export default GridRow;
